import packageJson from "@/package.json";
import { AppConstants } from "@/app/constants";
import { resolveGuiVersionLabel } from "@/app/shared/site-version";

export const SITE_STORAGE_VERSION_KEY = "ui:site-storage-version";

const CURRENT_SITE_STORAGE_VERSION = resolveCurrentSiteStorageVersion();

const ACTIVE_LOCAL_STORAGE_KEYS = new Set<string>([
  SITE_STORAGE_VERSION_KEY,
  AppConstants.SessionId,
  AppConstants.Locale,
  "theme",
  "ui:header-menu-hint-dismissed",
  "ui:main:chart-time-interval",
  "ui:monitoring:coin-surface-collapsed",
  "ui:monitoring:chart-time-interval",
  "ui:settings:coin-info-collapsed",
  "ui:pool-config:surface-collapsed",
  "ui:pool-config:state-surface-collapsed",
  "ui:read-site-messages:v1",
  "runtime_asset_reload_count",
  "runtime_asset_reload_ts",
]);

const ACTIVE_SESSION_STORAGE_KEYS = new Set<string>([
  "ui:monitoring:chart-section-tab",
]);

function resolveCurrentSiteStorageVersion(): string {
  const candidates = [
    process.env.NEXT_PUBLIC_SITE_VERSION,
    process.env.NEXT_PUBLIC_STORAGE_VERSION,
    resolveGuiVersionLabel(),
    packageJson.version,
  ];

  for (const candidate of candidates) {
    if (typeof candidate != "string") continue;
    const normalized = candidate.trim();
    if (normalized.length > 0) return normalized;
  }

  return "1";
}

function collectStaleKeys(
  storage: Storage,
  activeKeys: Set<string>
): string[] {
  const staleKeys: string[] = [];

  for (let i = 0; i < storage.length; i += 1) {
    const key = storage.key(i);
    if (!key) continue;
    if (activeKeys.has(key)) continue;
    staleKeys.push(key);
  }

  return staleKeys;
}

function removeKeys(storage: Storage, keys: string[]): void {
  for (const key of keys) {
    storage.removeItem(key);
  }
}

export function ensureSiteStorageVersion(): void {
  if (typeof window == "undefined") return;

  try {
    const savedVersion = localStorage.getItem(SITE_STORAGE_VERSION_KEY);
    if (savedVersion == CURRENT_SITE_STORAGE_VERSION) return;

    const staleLocalStorageKeys = collectStaleKeys(
      localStorage,
      ACTIVE_LOCAL_STORAGE_KEYS
    );
    const staleSessionStorageKeys = collectStaleKeys(
      sessionStorage,
      ACTIVE_SESSION_STORAGE_KEYS
    );

    removeKeys(localStorage, staleLocalStorageKeys);
    removeKeys(sessionStorage, staleSessionStorageKeys);

    localStorage.setItem(SITE_STORAGE_VERSION_KEY, CURRENT_SITE_STORAGE_VERSION);
  } catch {
    // Ignore storage errors for privacy mode/quota.
  }
}
